import React from 'react'
import Link from 'gatsby-link'
import styled, { keyframes } from "styled-components";

import { fetchPublicSectorData } from '../utils/api';
import Loader from '../components/loader';
import Card from '../components/Card';

const cardEntry = keyframes`
  to {
    transform: translateY(0);
    opacity: 1;
  }
`;

const DivGrid = styled.div`
  display: grid;
  grid-gap: 32px;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  grid-template-rows: auto;
}
`;

const StyledArticle = styled.article`
  padding: 0;
  margin: 0;
  animation: ${cardEntry} .8s ease 1;
  animation-delay: 0.${props => props.delay}s;
  animation-fill-mode: forwards;
  transform: translateY(80px);
  opacity: 0;
  height: 100%;
  min-height: 300px;
`;


class PublicSector extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      posts: []
    }
  }

  componentDidMount() {
    fetchPublicSectorData(posts => {
      this.setState({
        posts
      });
    });
  }

  render() {
    if (this.state.posts.length === 0){
    return <Loader />
  }

  const renderPosts = this.state.posts.map((post, i) => {
    return (
    <StyledArticle key={i} delay={i}>
      <Card {...post} />
    </StyledArticle>
    )
  });

    return(
      <div>
        <h1 className="pageTitle">PUBLIC SECTOR</h1>
        <DivGrid>
          {renderPosts}
        </DivGrid>
      </div>
    )
  }
}

export default PublicSector





// WEBPACK FOOTER //
// ./src/pages/publicsector.js